/**
 * Module dependencies.
 */

import classnames from 'classnames';
import React, { CSSProperties, ReactNode } from 'react';
import { Label } from '../label/label';
import styles from './form-field.module.less';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  label?: string;
  children: ReactNode;
  style?: CSSProperties;
};

/**
 * Export `FormField` component.
 */

export function FormField({ className, label, children, style }: Props): JSX.Element {
  return (
    <div className={classnames(styles.wrapper, className)} style={style}>
      {label && <Label>{label}</Label>}

      {children}
    </div>
  );
}
